"use strict";
import React from "react";
import { Select, MenuItem, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { useNavigate } from "react-router-dom";
import { primaryColor, secondaryColor } from "../../utils/constants";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
        width: "0.1px",
        borderRadius: "var(--radius-md)",
        position: "relative",
        border: "none",
        fontSize: "var(--font-size-normal)",
        backgroundColor: `${primaryColor}`,
        padding: "0px 0px 5px 4px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        color: `${secondaryColor}`,
        fontFamily: "Livvic",
    },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    "& .MuiSelect-select": {
        backgroundColor: `${primaryColor} !important`,
        color: `${secondaryColor} !important`,
    },
    "& .MuiSelect-icon": {
        fontSize: "var(--font-size-normal)",
    },
}));

const StyledMenuItem = styled(MenuItem)({
    backgroundColor: "none !important",
    color: "none !important",
    "&.Mui-selected": {
        backgroundColor: "grey !important",
        color: "none !important",
    },
    "&:focus": {
        backgroundColor: "grey !important",
        color: `${primaryColor} !important`,
    },
});

const menuProps = {
    PaperProps: {
        style: {
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            maxHeight: "none",
            boxShadow: "none",
            borderRadius: "var(--radius-md)",
        },
    },
    disableScrollLock: false,
};

const dropdownMenuProps = {
    ...menuProps,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "right",
    },
};

const AudiobookRolesNavBar = ({
    projectFile,
    handleWork,
    getLanguageName,
}) => {
    const navigate = useNavigate();

    const workTypes = [
        { id: "performancedirection", name: "Performance Direction" },
        { id: "finalqa", name: "Final QA Review" }
    ];

    return (
        <StyledSelect input={<BootstrapInput />} MenuProps={menuProps}>
            {workTypes.map((type, index) => (
                <StyledMenuItem key={index}>
                    <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Grid>{type.name}</Grid>
                        <Grid>
                            <StyledSelect
                                size="small"
                                defaultValue="Start Working"
                                MenuProps={dropdownMenuProps}
                            >
                                <StyledMenuItem value="Start Working">
                                    Start Working
                                </StyledMenuItem>
                                {projectFile?.finalLanguages?.map((language, langIndex) => (
                                    <StyledMenuItem
                                        key={langIndex}
                                        value={language}
                                        onClick={() => handleWork(type.id, language)}
                                    >
                                        {getLanguageName(language)}
                                    </StyledMenuItem>
                                ))}
                            </StyledSelect>
                        </Grid>
                    </Grid>
                </StyledMenuItem>
            ))}
            <StyledMenuItem onClick={() => navigate(`/audiobooks/details/${projectFile.id}`)}>
                Analyze
            </StyledMenuItem>
            <StyledMenuItem onClick={() => navigate(`/audiobooks/actions/${projectFile.id}`)}>
                Admin Actions
            </StyledMenuItem>
        </StyledSelect>
    );
};

export default AudiobookRolesNavBar;
